import { createFileRoute } from '@tanstack/react-router';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { QtiTestRendererRoot } from '@/features/qti-test-renderer/components/QtiTestRendererRoot';

export const Route = createFileRoute('/admin/qti-test-render')({
  component: RouteComponent,
  ssr: false,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      url: (search.url as string) ?? '',
    };
  },
});

function RouteComponent() {
  const breadcrumbItems: BreadcrumbItemProps[] = [
    {
      label: 'Admin',
      link: {
        to: '/admin',
      },
    },
    {
      label: 'QTI Test Renderer',
      link: {
        to: '/admin/qti-test-render',
      },
    },
  ];

  return (
    <AdminPageContent className="relative">
      <AdminPageHeader breadcrumbItems={breadcrumbItems} />
      <QtiTestRendererRoot />
    </AdminPageContent>
  );
}
